import {
  css
} from 'lit';

export const LillyLogoStyle = css`
.lds-lilly-logo {
  display: block;
  box-sizing: content-box;
}
.lilly-logo-xs {
  width: var(--lds-spacing-lilly-logo-width-xs);
  height: var(--lds-spacing-lilly-logo-height-xs);
  padding-top: var(--lds-spacing-lilly-logo-padding-top-xs);
  padding-right: var(--lds-spacing-lilly-logo-padding-right-xs);
  padding-bottom: var(--lds-spacing-lilly-logo-padding-bottom-xs);
  padding-left: var(--lds-spacing-lilly-logo-padding-left-xs);
}
.lilly-logo-sm {
  width: var(--lds-spacing-lilly-logo-width-sm);
  height: var(--lds-spacing-lilly-logo-height-sm);
  padding-top: var(--lds-spacing-lilly-logo-padding-top-sm);
  padding-right: var(--lds-spacing-lilly-logo-padding-right-sm);
  padding-bottom: var(--lds-spacing-lilly-logo-padding-bottom-sm);
  padding-left: var(--lds-spacing-lilly-logo-padding-left-sm);
}
.lilly-logo-md {
  width: var(--lds-spacing-lilly-logo-width-md);
  height: var(--lds-spacing-lilly-logo-height-md);
  padding-top: var(--lds-spacing-lilly-logo-padding-top-md);
  padding-right: var(--lds-spacing-lilly-logo-padding-right-md);
  padding-bottom: var(--lds-spacing-lilly-logo-padding-bottom-md);
  padding-left: var(--lds-spacing-lilly-logo-padding-left-md);
}
.lilly-logo-lg {
  width: var(--lds-spacing-lilly-logo-width-lg);
  height: var(--lds-spacing-lilly-logo-height-lg);
  padding-top: var(--lds-spacing-lilly-logo-padding-top-lg);
  padding-right: var(--lds-spacing-lilly-logo-padding-right-lg);
  padding-bottom: var(--lds-spacing-lilly-logo-padding-bottom-lg);
  padding-left: var(--lds-spacing-lilly-logo-padding-left-lg);
}
.lilly-logo-xl {
  width: var(--lds-spacing-lilly-logo-width-xl);
  height: var(--lds-spacing-lilly-logo-height-xl);
  padding-top: var(--lds-spacing-lilly-logo-padding-top-xl);
  padding-right: var(--lds-spacing-lilly-logo-padding-right-xl);
  padding-bottom: var(--lds-spacing-lilly-logo-padding-bottom-xl);
  padding-left: var(--lds-spacing-lilly-logo-padding-left-xl);
}
.lilly-logo-fit {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 100%;
}
.lilly-logo-fit svg {
  width: 64.7%;
  height: 50%;
}
.lds-lilly-logo:focus {
  outline-color: var(--lds-color-link-outline-focus);
  outline-offset: var(--lds-border-link-focus-outline-offset);
  outline-style: var(--lds-border-link-focus-outline-style);
  outline-width: var(--lds-border-link-focus-outline-width);
}
.pd-0 { padding: 0 !important; }
.pt-0 { padding-top: 0 !important; }
.pb-0 { padding-bottom: 0 !important; }
.pl-0 { padding-left: 0 !important; }
.pr-0 { padding-right: 0 !important; }
`;

export default LillyLogoStyle;
